import CustomTextarea from 'designer/component/element/Textarea'
import ControlWrapper from './ControlWrapper'

const TextareaControl = (props) => {
  return <ControlWrapper {...props} Component={CustomTextarea} />
}

export default TextareaControl
